import { Pagination, PaginationProps } from 'antd';
import { useState } from 'react';
import styled, { useTheme } from 'styled-components';
import { ReactComponent as Next } from '../../../assets/icons/next.svg';
import { ReactComponent as NextDisabled } from '../../../assets/icons/nextDisabled.svg';
import { ReactComponent as Prev } from '../../../assets/icons/prev.svg';
import { ReactComponent as PrevDisabled } from '../../../assets/icons/prevDisabled.svg';
import SizedBox from '../components/box/sizedBox';
import Center from '../components/center';
import { LXbody, LXh5 } from '../texts/lxText';
interface LXPaginationProps {
  current: number;
  pageSize: number;
  total: number;
  onChange: (page: number) => void;
  disabled?: boolean;
}

const BorderedBackground = styled.div`
  border-radius: 8px;
  width: 24px;
  height: 24px;
  background-color: #eeeeee;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LXPagination: React.FC<LXPaginationProps> = (props) => {
  const [current, setCurrent] = useState(props.current + 1);
  const theme = useTheme();

  const isLast = (currentPageNumber: number): boolean => {
    if (currentPageNumber === Math.ceil(props.total / props.pageSize)) {
      return true;
    } else {
      return false;
    }
  };

  const itemRender: PaginationProps['itemRender'] = (
    pageNumber,
    type,
    originalElement
  ) => {
    if (type === 'prev') {
      if (current === 1) {
        return <PrevDisabled></PrevDisabled>;
      }
      return <Prev></Prev>;
    }
    if (type === 'next') {
      if (isLast(current)) {
        return <NextDisabled></NextDisabled>;
      }
      return <Next></Next>;
    }
    if (type === 'page') {
      if (pageNumber === current) {
        return (
          <BorderedBackground>
            <LXh5 color={theme.colors.body}>{pageNumber}</LXh5>
          </BorderedBackground>
        );
      } else {
        return (
          <SizedBox width={24} height={24}>
            <Center>
              <LXbody>{pageNumber}</LXbody>
            </Center>
          </SizedBox>
        );
      }
    }
    return originalElement;
  };

  return (
    <Pagination
      disabled={props.disabled}
      pageSize={props.pageSize}
      total={props.total}
      current={current}
      showSizeChanger={false}
      itemRender={itemRender}
      onChange={(pageNumber, __) => {
        setCurrent(pageNumber);
        props.onChange(pageNumber - 1);
      }}
    ></Pagination>
  );
};

export default LXPagination;
